import { render, staticRenderFns } from "./ScanlogsMembers.vue?vue&type=template&id=2b6b998b"
import script from "./ScanlogsMembers.vue?vue&type=script&lang=js"
export * from "./ScanlogsMembers.vue?vue&type=script&lang=js"
import style0 from "./ScanlogsMembers.vue?vue&type=style&index=0&id=2b6b998b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports